<template>
  <div class="view-wrap bg-dark">
    <div class="view-content bg-regular">
      <section class="element xs centered text-center">
        <img class="bear" src="./images/upgrade-success.svg" alt="">
        <p>Your Bear has been upgraded to RememBear Premium</p>
        <a href="remembear://sync" class="btn btn-lg">Open the App</a>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  name: 'upgraded',
  data () {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="stylus" src="./upgraded.styl" >



// WEBPACK FOOTER //
// src/views/upgraded/upgraded.vue